import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {ScreeningCriteriaCreateDTO, ScreeningCriteriaDTO, ScreeningCriteriaEvalDTO} from '../../dto/screening-criteria';

@Injectable({
  providedIn: 'root',
})
export class ScreeningCriteriaService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/project';

  getCriteria(projectId: number): Observable<ScreeningCriteriaDTO[]> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.get<ScreeningCriteriaDTO[]>(`${this.apiUrl}/${projectId}/screening-criteria`);
  }

  evalScreeningCriteria(projectId: number, criteria: string): Observable<ScreeningCriteriaEvalDTO> {
    if (!criteria) {
      throw new Error('criteria is required');
    }
    const params = new HttpParams().set('criteria', criteria);
    return this.http.get<ScreeningCriteriaEvalDTO>(`${this.apiUrl}/${projectId}/screening-criteria/eval`, {params});
  }

  getCriteriaById(projectId: number, id: number): Observable<ScreeningCriteriaDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    if (!id) {
      throw new Error('Id is required');
    }
    return this.http.get<ScreeningCriteriaDTO>(`${this.apiUrl}/${projectId}/screening-criteria/${id}`);
  }

  createCriteria(projectId: number, criteria: ScreeningCriteriaCreateDTO): Observable<ScreeningCriteriaDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.post<ScreeningCriteriaDTO>(`${this.apiUrl}/${projectId}/screening-criteria`, criteria);
  }

  updateCriteria(projectId: number, id: number, criteria: ScreeningCriteriaDTO): Observable<ScreeningCriteriaDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    if (!id) {
      throw new Error('Id is required');
    }
    return this.http.put<ScreeningCriteriaDTO>(`${this.apiUrl}/${projectId}/screening-criteria/${id}`, criteria);
  }

  deleteCriteria(projectId: number, id: number): Observable<HttpResponse<string>> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    if (!id) {
      throw new Error('Id is required');
    }
    return this.http.delete(`${this.apiUrl}/${projectId}/screening-criteria/${id}`, {
      observe: 'response',
      responseType: 'text'
    });
  }
}

